import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

export const updateUser = async data => {
  return privateRequest.post(ConfEnv.API_URL.URL_UPDATE_PROFILE, data);
};

export const updatePassword = async data => {
  return privateRequest.post(ConfEnv.API_URL.URL_CHANGE_PASSWORD, data);
};
